import { render, staticRenderFns } from "./MaterialUploadImage.vue?vue&type=template&id=27195ceb"
import script from "./MaterialUploadImage.vue?vue&type=script&lang=js"
export * from "./MaterialUploadImage.vue?vue&type=script&lang=js"
import style0 from "./MaterialUploadImage.vue?vue&type=style&index=0&id=27195ceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports